<template>
  <v-virtual-scroll :bench="5" :items="filteredPerson" height="inherit" item-height="140">
    <template v-slot:default="{ item }">
      <v-card flat class="employee-item" :to="`/employee/${item.id}`">
        <employee-row :employee="item" :photo-filename="getPhotoFilename(item)"></employee-row>
      </v-card>
    </template>
  </v-virtual-scroll>
</template>
<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import EmployeeRow from '@/modules/employee/EmployeeRow';
import employeeService from '@/modules/employee/employeeService';

export default {
  name: 'Employee',
  mixins: [common, configMixin, dateTimeMixin],

  components: {
    EmployeeRow,
  },
  props: {
    filteredPerson: Array,
    photoByEmployeeId: Object,
  },
  methods: {
    getPhotoFilename(item) {
      return employeeService.getPhotoFilename(this.photoByEmployeeId, item);
    },
  },
};
</script>
<style>
.employee-item {
  height: 135px;
  overflow: visible;
}
</style>
